import { config } from 'affiny-core/env';
import { capitalize } from 'affiny-core/helpers/string/capitalize';
import { EPersonalityTypes } from 'affiny-core/modules/personalityReport/types';
import { SvgPersonalityReport } from 'affiny-desktop/src/components/svg';
import { Flex, rem, ShadowBox, Text } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPersonalityReportLayerOnboardingCard {
  personalityType: EPersonalityTypes | undefined;
  introOnboardingCard: string;
}

export const PersonalityReportLayerOnboardingCard = ({
  personalityType,
  introOnboardingCard,
}: IPersonalityReportLayerOnboardingCard) => {
  const { t } = useTranslation();

  return (
    <Flex
      alignItems="center"
      justifyContent="top"
      flexDirection="column"
      mx="xLarge"
      px={rem(64)}
    >
      <Text fontSize={rem(24)} fontWeight="600" mt="xLarge">
        {t('personalityReport.title')}
      </Text>
      <Text
        fontSize={rem(18)}
        mt="medium"
        color="secondary"
        textAlign="center"
        lineHeight={rem(30)}
      >
        {t('personalityReport.subTitle', {
          brand: capitalize(config.configStrategy.getBrand?.()),
        })}
      </Text>
      <ShadowBox
        pr={rem(32)}
        pt={rem(32)}
        pb={rem(32)}
        width="100%"
        my="xLarge"
      >
        <Flex>
          <Flex mr={rem(8)} alignItems="center">
            <SvgPersonalityReport personalityType={personalityType} />
          </Flex>
          <Flex flexDirection="column">
            <Text fontSize={rem(18)} color="secondary" mt={rem(8)}>
              {t('personalityReport.vision.title')}
            </Text>
            <Text
              fontSize={rem(36)}
              fontWeight="600"
              fontStyle="italic"
              lineHeight={rem(32)}
              color={personalityType?.toLowerCase()}
              mt={rem(4)}
            >
              {t('personalityReport.personalityTypes.' + personalityType)}
            </Text>
            <Text
              fontSize={rem(18)}
              color="primary"
              mt={rem(24)}
              lineHeight={rem(28)}
            >
              {introOnboardingCard}
            </Text>
          </Flex>
        </Flex>
      </ShadowBox>
    </Flex>
  );
};
